export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/)
}
